import { GetProductsResponse } from '@ph-model/response/getproducts.response';

/**
 * Portal-specific product filter group overrides applied at products intake.
 * Left-side grouped filters use `productCategory` as the group name.
 * No-op when overrides are empty (non-configured portals).
 */
export function applyProductCategoryOverrides(
  response: GetProductsResponse,
  overrides: Record<string, string> | undefined
): GetProductsResponse {
  if (!overrides || !Object.keys(overrides).length) {
    return response;
  }

  const products = response?.availableOptions?.products?.productItem;
  if (!products?.length) {
    return response;
  }

  products.forEach((product) => {
    const overrideCategory = overrides[product.productCode];
    if (overrideCategory) {
      product.productCategory = overrideCategory;
    }
  });

  return response;
}
